function clamp(_: number, max: number): number;
// eslint-disable-next-line @typescript-eslint/unified-signatures
function clamp(_: number, min: number, max: number): number;
function clamp(_: number, _min: number, _max?: number): number {
  const min = _max === undefined ? 0 : _min;
  const max = _max === undefined ? _min : _max;
  if (_ < min) {
    return min;
  }
  if (_ > max) {
    return max;
  }
  return _;
}

export default clamp;
